import { FeedItemContext } from '../../../../../../lib/feed/interfaces'
import { appendInternalTrackingSearchParams } from '../../../utilities/analytics'
import { header, footer, language, media } from '../feed_item'
import { removeSpecialCharacters, createAttributes } from '../utils'

const gamesCarouselTemplate = (feedItem: FeedItemContext) => {
  const {
    link,
    title,
    duration,
    publisherLogo,
    publisherDarkLogo,
    publisherName,
    isVideoLink,
    thumbnailUrl,
    isSponsored,
    contentType,
    contentTypeText,
    description,
    index,
    pub_time,
    layout
  } = feedItem

  return `
  <article
  ${createAttributes(feedItem)}
  data-gtm-scroll-count=${index}>
  <a class="block-item__body"
     href="${appendInternalTrackingSearchParams(link)}"
     data-mp-cct>
    ${media(thumbnailUrl, isVideoLink, duration, layout)}
  
    ${header(
      isSponsored,
      publisherDarkLogo,
      publisherLogo,
      publisherName,
      isVideoLink,
      layout
    )}
  
    <h1 class="block-item__title ${language}">
        <span class="block-item__headline">${title}</span>
        <span class="block-item__subtitle ${language}"></span>
    </h1>
  
    ${
      description
        ? `<p class="block-item__description ${language}">${removeSpecialCharacters(
            description
          )}</p>`
        : ''
    }
    </a>

    ${footer(
      title,
      link,
      isSponsored,
      contentTypeText,
      contentType,
      language,
      layout,
      publisherDarkLogo,
      publisherLogo,
      publisherName,
      isVideoLink,
      pub_time
    )}
    </article>
  `
}

export default gamesCarouselTemplate
